export default function StorySection() {
  return (
    <section className="bg-[#FAF8F5] py-36 px-8 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Editorial pair */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center mb-32">
          <div className="lg:order-2">
            <p className="text-[#C9A961] tracking-[0.3em] text-xs uppercase font-light mb-6">
              Our Story
            </p>
            <h2 className="font-serif text-[#1A1A1A] text-4xl md:text-5xl font-normal leading-[1.2] mb-8">
              Born from a love of<br />
              the <em className="italic">beautifully</em><br />
              considered table.
            </h2>
            <p className="text-[#8A7F74] text-base font-light leading-relaxed mb-6">
              Table Privé began not in a commercial kitchen or a corporate boardroom — but at a single, perfect dinner. A table set for twelve, in a private residence in London's West End, where every guest remarked that the experience had transcended anything they had attended before.
            </p>
            <p className="text-[#8A7F74] text-base font-light leading-relaxed mb-6">
              That evening revealed something essential: that when the environment is designed with true intention — the light, the scent, the service, the silence — dinner becomes ceremony.
            </p>
            <p className="text-[#8A7F74] text-base font-light leading-relaxed">
              Since that evening, we have created over four hundred bespoke luxury private dining experiences across London, Paris, Milan, and Monaco — each one unrepeatable, each one entirely the client's own.
            </p>
          </div>

          <div className="lg:order-1 relative">
            <div className="overflow-hidden rounded-lg" style={{ aspectRatio: "4/5" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/c88e7867ebc01b94deafccb36262ddb4.jpg"
                alt="Table Privé origin story luxury dining"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#0D0D0D] rounded-lg px-8 py-6 max-w-xs">
              <p className="font-serif text-[#C9A961] text-2xl mb-1">400+</p>
              <p className="text-[#8A7F74] text-xs font-light tracking-wide">Bespoke experiences across London, Paris, Milan &amp; Monaco</p>
            </div>
          </div>
        </div>

        {/* Wide atmospheric image */}
        <div className="relative overflow-hidden rounded-lg" style={{ aspectRatio: "16/7" }}>
          <img
            src="https://readdy.ai/api/search-image?query=luxury%20long%20dining%20table%20fully%20styled%20white%20flowers%20gold%20candelabras%20crystal%20glasses%20soft%20light%20evening%20elegant%20private%20event%20haute%20couture%20hospitality%20cinematic%20wide%20angle&width=1600&height=700&seq=tp-story-wide&orientation=landscape"
            alt="Table Privé bespoke luxury event"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />
          <div className="absolute bottom-10 left-12">
            <p className="font-serif italic text-[#FAF8F5] text-xl md:text-2xl opacity-80">
              "An experience designed only for you."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
